export default __webpack_public_path__ + "static/media/IF_MyStrengths_FullProfile_Desc_04.e6bca8f1.jpg";